import { render, staticRenderFns } from "./BookingServiceForm.vue?vue&type=template&id=4970eb5b&scoped=true&"
import script from "./BookingServiceForm.vue?vue&type=script&lang=js&"
export * from "./BookingServiceForm.vue?vue&type=script&lang=js&"
import style0 from "./BookingServiceForm.vue?vue&type=style&index=0&id=4970eb5b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4970eb5b",
  null
  
)

export default component.exports